// // import { Outlet } from "react-router-dom";

// // import SidebarAdmin from "../../ui/sidebarAdmin/index.js";
// // import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";

// // export default function AdminLayout() {
// //   const { action } = useHeaderAction();
// //   return (
// //     <div className="flex w-full bg-neutral-100  mx-auto h-screen">
// //       <SidebarAdmin />
// //       <div className="flex flex-col gap-2 p-5 relative w-full h-full">
// //         <div className="bg-white rounded-xl p-2 h-20 shadow-[0_2px_4px_-1px_#0000000F,0_4px_6px_-1px_#0000001A] ">
// //           {action && (
// //             <div className="flex-1 h-full items-center  z-20">
// //               {action}
// //             </div>
// //           )}
// //         </div>
// //         <div className="w-full bg-white rounded-xl mt-2 p-7 overflow-auto no-scrollbar flex-1">
// //           <Outlet />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// import { Outlet, useLocation } from "react-router-dom";

// import SidebarAdmin from "../../ui/sidebarAdmin/index.js";
// import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";

// export default function AdminLayout() {
//   const { action } = useHeaderAction();
//   const location = useLocation();
//   const noSideBar = ["/admin/login"];

//   const isNoSideBar = noSideBar.includes(location.pathname);

//   if (isNoSideBar) {
//     return (
//       <div className="w-full">
//         <Outlet />
//       </div>
//     );
//   }

//   return (
//     <div className="flex w-full bg-neutral-100 mx-auto h-screen">
//       <SidebarAdmin />
//       <div className="flex flex-col gap-2 p-5 relative w-full h-full">
//         <div className="bg-white rounded-xl p-2 h-16 shadow-[0_2px_4px_-1px_#0000000F,0_4px_6px_-1px_#0000001A]">
//           {action && (
//             <div className="flex-1 h-full items-center z-20">
//               {action}
//             </div>
//           )}
//         </div>
//         <div className="w-full bg-white rounded-xl mt-2 p-7 overflow-auto no-scrollbar flex-1">
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// }

import { Outlet, useLocation } from "react-router-dom";
import SidebarAdmin from "../../ui/sidebarAdmin/index.js";
import { useHeaderAction } from "../../../core/provider/HeaderActionProvider/HeaderAction.js";
import Topbar from "./componentAdmin/Topbar.js";

export default function AdminLayout() {
  const { action } = useHeaderAction();
  const location = useLocation();
  const noSideBar = ["/admin/login"];

  const isNoSideBar = noSideBar.includes(location.pathname);

  if (isNoSideBar) {
    return (
      <div className="w-full">
        <Outlet />
      </div>
    );
  }

  return (
    <div
      dir="rtl"
      className="flex w-full h-screen overflow-hidden bg-neutral-100"
    >
      {/* Sidebar - سمت راست */}
      <SidebarAdmin />

      {/* Main Content */}
      <div className="flex flex-col flex-1 min-w-0 h-screen">
        {/* Topbar */}
        <Topbar action={action} />

        {/* Content */}
        <main className="flex-1 min-w-0 min-h-0 p-2 overflow-hidden">
    <div className="w-full h-full p-3 bg-white rounded-2xl shadow-sm ring-1 ring-neutral-200/60 overflow-hidden flex flex-col">
        <Outlet />
    </div>
</main>
      </div>
    </div>
  );
}